import { render, staticRenderFns } from "./BulkPalletSet.vue?vue&type=template&id=5bbb823e&scoped=true"
import script from "./BulkPalletSet.vue?vue&type=script&lang=js"
export * from "./BulkPalletSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb823e",
  null
  
)

export default component.exports